import { Theme, withStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'

export const BigTooltip = withStyles((theme: Theme) => ({
    tooltip: {
        fontSize: 12,
    },
}))(Tooltip)
